import { queryParams } from '@/plugins/axios';

export function all(context, payload) {
  const getUrl = `/points-of-interest/${queryParams(payload)}`;

  return this._vm.$axios.get(getUrl);
}
